/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Meta_DescriptionInputs */

const es_l6_meta_description = /** @type {(inputs: L6_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tu barco ya está en Lista 6ª? Gestiona tus reservas en un solo sitio con la comisión plana más baja de la categoría: 15% + IVA.`)
};

const gl_l6_meta_description = /** @type {(inputs: L6_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O teu barco xa está na Lista 6ª? Xestiona as túas reservas nun só sitio coa comisión plana máis baixa da categoría: 15% + IVE.`)
};

const en_l6_meta_description = /** @type {(inputs: L6_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is your boat already on List 6? Manage bookings in one place with the category's lowest flat commission: 15% + VAT.`)
};

/**
* | output |
* | --- |
* | "Is your boat already on List 6? Manage bookings in one place with the category's lowest flat commission: 15% + VAT." |
*
* @param {L6_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_meta_description = /** @type {((inputs?: L6_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_meta_description(inputs)
	if (locale === "en") return en_l6_meta_description(inputs)
	return es_l6_meta_description(inputs)
});